import { useState, useEffect, useRef, MutableRefObject } from "react";

export default function useOutsideClickHandler<T>(
  initialIsVisible = false,
  refToExclude: React.MutableRefObject<T | undefined>[]
) {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
  const ref = useRef() as MutableRefObject<any>;

  const handleHideDropdown = (event: any) => {
    if (event.key === "Escape") {
      setIsComponentVisible(false);
    }
  };

  const handleClickOutside = (event: any) => {
    if (
      !refToExclude?.every((v) => (v as any)?.current && !(v as any).current.contains(event.target))
    ) {
      return;
    }


    if (ref.current && !((ref.current as any).contains(event.target))) {
      setIsComponentVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleHideDropdown, true);
    document.addEventListener("mousedown", handleClickOutside, true);
    return () => {
      document.removeEventListener("keydown", handleHideDropdown, true);
      document.removeEventListener("mousedown", handleClickOutside, true);
    };
  });

  return { ref, isComponentVisible, setIsComponentVisible };
}
